import { theme } from './index'

export default ({
  colors = {},
  decoration = {},
  screens = {},
  screensMinMax = {},
  font = {},
  gutter = theme.fontFamily,
  breakpoints = [
    theme.screens.small,
    theme.screens.medium,
    theme.screens.xLarge,
  ],
  fontFamily = theme.fontFamily,
  fontFaces = theme.fontFaces,
  components = theme.components,
} = {}) => ({
  colors: {
    ...theme.colors,
    ...colors,
  },
  decoration: {
    ...theme.decoration,
    ...decoration,
  },
  screens: {
    ...theme.screens,
    ...screens,
  },
  screensMinMax: {
    xs: {
      ...theme.screensMinMax.xs,
      ...screensMinMax.xs,
    },
    sm: {
      ...theme.screensMinMax.sm,
      ...screensMinMax.sm,
    },
    md: {
      ...theme.screensMinMax.md,
      ...screensMinMax.md,
    },
    lg: {
      ...theme.screensMinMax.lg,
      ...screensMinMax.lg,
    },
  },
  font: {
    weights: {
      ...theme.font.weights,
      ...font.weights,
    },
    sizes: {
      ...theme.font.sizes,
      ...font.sizes,
    },
    lineHeight: {
      ...theme.font.lineHeight,
      ...font.lineHeight,
    },
  },
  gutter,
  breakpoints,
  fontFamily,
  fontFaces,
  components: {
    modal: {
      ...theme.components.modal,
      ...components.modal,
    },
    input: {
      ...theme.components.input,
      ...components.input,
    },
    button: {
      ...theme.components.button,
      ...components.button,
    },
    buttonBordered: {
      ...theme.components.buttonBordered,
      ...components.buttonBordered,
    },
    buttonUnstyled: {
      ...theme.components.buttonUnstyled,
      ...components.buttonUnstyled,
    },
    simpleInput: {
      ...theme.components.simpleInput,
      ...components.simpleInput,
    },
    paginatorButton: {
      ...theme.components.paginatorButton,
      ...components.paginatorButton,
    },
    table: {
      ...theme.components.table,
      ...components.table,
    },
    stepper: {
      ...theme.components.stepper,
      ...components.stepper,
    },
    checks: {
      ...theme.components.checks,
      ...components.checks,
    },
    dropdown: {
      ...theme.components.dropdown,
      ...components.dropdown,
    },
    placeSelect: {
      ...theme.components.placeSelect,
      ...components.placeSelect,
    },
  },
})
